import dynamic from 'next/dynamic';

export const Dots = dynamic(() => import('./Dots'), { ssr: false });
export const ScatterChart = dynamic(() => import('./ScatterChart'), {
  ssr: false,
});
